import { useMemo } from 'react';

import { useShortUrlsLoader } from './useShortUrlsLoader';

// Legacy display-only API: returns the shortener URL when available, otherwise
// the original longUrl. Tracking-aware consumers should use `useShortUrlsInfo`
// to also get a `share_id` fallback before/after the shortener call.
export function useShortUrls<T extends Record<string, string>>(urlsMapArg: T): Readonly<Record<keyof T, string>> {
	const { urlsMap, state } = useShortUrlsLoader(urlsMapArg);

	return useMemo(
		() =>
			// oxlint-disable-next-line typescript/no-unsafe-type-assertion
			Object.entries(urlsMap).reduce<Record<string, string>>((acc, [name, url]) => {
				const cacheState = state.cache[url];

				// oxlint-disable-next-line no-param-reassign
				acc[name] = (cacheState?.status === 'loaded' ? cacheState.info.url : undefined) || url;
				return acc;
			}, {}) as Record<keyof T, string>,
		[urlsMap, state],
	);
}
